export interface Authority {
  acronym: string
  country: string
  flag: string
  name: string
}

export const authorities: Authority[] = [
  {
    acronym: 'ANAC',
    country: 'Argentina',
    flag: '🇦🇷',
    name: 'Administración Nacional de Aviación Civil',
  },
  { acronym: 'AEROCIVIL', country: 'Colombia', flag: '🇨🇴', name: 'Aeronáutica Civil' },
  { acronym: 'AFAC', country: 'México', flag: '🇲🇽', name: 'Agencia Federal de Aviación Civil' },
  { acronym: 'DGAC', country: 'Chile', flag: '🇨🇱', name: 'Dirección General de Aviación Civil' },
  { acronym: 'DGCA', country: 'Perú', flag: '🇵🇪', name: 'Dirección General de Aviación Civil' },
]

export const authorityCoverage = [
  'Alturas máximas exactas',
  'Multas reales y vigentes',
  'Contactos directos de autoridades',
  'Procesos de certificación actualizados',
]
